export default "__VITE_ASSET__x6gDF5Yh__"